import { OperationCompletionModel } from "./operation-completion.model";


export class LineOperationCompletionModel {
    lineId: string;
    lineDesc: string;
    breakPointsOperations: string[]; // the operations at 30% 60% 90% 100% like 3,6,9th operations in the list 
    totalOperations: string[]; // all operations in the line
    lineWiseGarmentCompletion: OperationCompletionModel[];

    constructor(lineId: string,
        lineDesc: string,
        breakPointsOperations: string[],
        totalOperations: string[],
        lineWiseGarmentCompletion: OperationCompletionModel[] ) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.breakPointsOperations = breakPointsOperations;
            this.totalOperations = totalOperations;
            this.lineWiseGarmentCompletion = lineWiseGarmentCompletion;
    }
}